import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QQQuestionnairePageViewModel } from 'src/app/models/qq-questionnaire-page.view-model';

@Component({
  selector: 'app-paging',
  templateUrl: './paging.component.html',
  styleUrls: ['./paging.component.scss'],
})
export class PagingComponent implements OnInit {
  @Input() page: QQQuestionnairePageViewModel;
  @Input() valid: boolean;
  @Input() firstPage: boolean;
  @Output() showInvalid = new EventEmitter();
  @Input() nextBtnText: string = "Continue"

  constructor() { }

  ngOnInit() { }

  async nextPage() {
    if (await this.page.nextPage()) {
      this.firstPage = this.page.questionnaire.currentPageIndex === 0;
    } else {
      this.showInvalid.emit();
    }
  }

  async prevPage() {
    await this.page.prevPage();
    this.firstPage = this.page.questionnaire.currentPageIndex === 0;
  }

}
